'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var Card = require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');
var react = require('@chakra-ui/react');
var useEditCard = require('./useEditCard.js');
var utils = require('@chakra-ui/utils');
var EditCardFooter = require('./EditCardFooter.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children"],
  _excluded2 = ["htmlProps"];
/**
 * `Edit card
 *
 * Handles design and functionality and returns a card element.
 *
 * @TODO: Functionality is not yet implemented.
 */
var EditCard = react.forwardRef(function (props, ref) {
  var children = props.children,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  var _useEditCard = useEditCard.useEditCard(rest),
    htmlProps = _useEditCard.htmlProps,
    context = _objectWithoutProperties__default["default"](_useEditCard, _excluded2);
  return /*#__PURE__*/React__default["default"].createElement(useEditCard.EditCardProvider, {
    value: context
  }, /*#__PURE__*/React__default["default"].createElement(Card.Card, _extends__default["default"]({
    ref: ref,
    as: "section",
    variant: "edit",
    "data-active": utils.dataAttr(context.isEditing && !context.isDisabled)
  }, htmlProps), children, /*#__PURE__*/React__default["default"].createElement(EditCardFooter.EditCardFooter, null)));
});
EditCard.displayName = 'EditCard';
exports.EditCard = EditCard;